import React from "react"
import { api, dialogOcupanccy, wizardDate } from "../widgets/Production";
import { calendarTrending, degreeOccupancyTime } from "../widgets/Charts";
import { windowsActive, hotels } from "../../../../config/Helpers";
import { latest as API_URL } from "../../../../config/api";
import ReactEcharts from "echarts-for-react";
import ByDate from "./Production/ByDate";
import Segment from "./Production/Segment";
import Channel from "./Production/Channel";
import Trending from "./Production/RoomNight";
import Allotment from "./Production/Allotment";
import Adr from "./Production/Adr";
import Revenue from "./Production/Revenue";
import axios from "axios";
const postUrlWidgets = API_URL + "widgets";

class Production extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data_degree_occupancy_time : {
                month_names: [],
                type_names : [],
                values : []
            },
            hotel_calendars : "",
            hotel_menu_show  : "hide-panel",
            current_hotel    : { key  : "All locations", value : "all" },
            dialog : {
                container : "",
                buttons : ""
            },
            details_window : "",
            current_list_result : "",
            current_sublist : {
                year: this.props.current_year,
                month: {
                    key: "",
                    value: ""
                },
                day:{
                    key: "",
                    value: ""
                },
            },
            optional_filters : {},
            current_list_head : this.props.current_year,
            //request_occupancy : " hide",
            update_component : "",
            action_component : "",
            statics : [],
            chart_pickup : {},
            statics_segments : [],
            statics_channels : [],
            statics_trimester : [],
            statics_aux : [],
            statics_segments_aux : [],
            statics_channels_aux : [],
            total_widgets : [],
            total_widgets_channels : [],
            filters_segment : [],
            filters_channels : [],
            filters_channels_aux : [],
            hidden_wdg_time : "show-widget complete",
            hidden_wdg_room_nights : "show-widget complete",
            hidden_wdg_adr : "show-widget complete",
            hidden_wdg_revenue : "show-widget complete",
            hidden_wdg_revpar : "show-widget complete",
            hide_widget_trimester : "hide-widget",
            key_filter_channel : null,
            filter_ms_active : "inactive",
            filter_month_active : "inactive",
            filter_trimester_active : "inactive",
            filter_segment_active : "inactive",
            request_status : "",
            key_trimester : "",
            active_chart_type : { key : "Day", value : "by_day"},
            tab_submodule : 'inactive',
            tab_filters : 'inactive',
            calendars : "",
            hotel_filters : "",
            calendar_request : "",
            hotels : hotels()
        }
        //this.getButtonsDetails  = this.getButtonsDetails.bind(this);
        // this.getMonthComponent  = this.getMonthComponent.bind(this);
        // this.getDaysComponent   = this.getDaysComponent.bind(this);
        // this.getDaysMonth       = this.getDaysMonth.bind(this);
        // this.getMonthDetails    = this.getMonthDetails.bind(this)

        //this.setSegments = this.setSegments.bind(this);
        //this.getAgencies = this.getAgencies.bind(this);
        //this.activeSegment = this.activeSegment.bind(this);
        this.getDefaultValues = this.getDefaultValues.bind(this);
        this.setDefaultValuesModule = this.setDefaultValuesModule.bind(this);
        //this.callMainRequest = this.callMainRequest.bind(this);

    }
    // setSegments(segments, key_time, filt) {
    //     let self = this;
        
    //     const status  =  (Object.keys(filt).length > 0) ? "active" : "inactive";
    //     if (segments !== null) {
    //         self.setState({
    //             filters_segment: segments,
    //             filter_month_active: status,
    //             key_time: filt,
    //             filter_ms_active : "active"
    //         }, function () {
    //             self.props.app.mainRequest();
    //         })
    //     } else {
    //         self.setState({
    //             filters_segment: [],
    //             filter_month_active: status,
    //             filter_segment_active: "inactive",
    //             statics_channels: {},
    //             segmentActive : {},
    //             filter_ms_active : "inactive"
    //         }, function(){
    //             self._widgetSegment.setState({
    //                 segmentActive : {}
    //             }, function(){
    //                 self.props.app.mainRequest();
    //             })
    //         })
    //     }
    // }
    // getAgencies(status, segmentActive) {
    //     let self = this;
    //     if (status === 'active') {
    //         self.setState({
    //             statics_channels: Object.assign({}, self.state.filters_channels),
    //             filter_segment_active : "active",
    //             segmentActive : segmentActive
    //         }, function(){
    //             setTimeout(() => {
    //                 this.forceUpdate();
    //             }, 100);
                
    //         })
    //     } else {
    //         self.setState({
    //             statics_channels : {},
    //             filter_segment_active : "inactive",
    //             segmentActive : {}

    //         }, function(){
    //             setTimeout(() => {
    //                 this.forceUpdate();
    //             }, 100);
    //         })
    //     }
    // }
    // activeSegment(status) {
    //     if (status === "inactive") {
    //         this.setState({
    //             filters_channels: [],
    //             statics_channels: []
    //         });
    //     }
    //     this.setState({
    //         filter_segment_active: status
    //     })
    // }
    getDefaultValues(){
        return {
            data_degree_occupancy_time : {
                month_names: [],
                type_names : [],
                values : []
            },
            hotel_calendars : "",
            hotel_menu_show  : "hide-panel",
            current_hotel    : { key  : "All locations", value : "all" },
            dialog : {
                container : "",
                buttons : ""
            },
            details_window : "",
            current_list_result : "",
            current_sublist : {
                year: this.props.current_year,
                month: {
                    key: "",
                    value: ""
                },
                day:{
                    key: "",
                    value: ""
                },
            },
            optional_filters : {},
            current_list_head : this.props.current_year,
            request_occupancy : " show",
            update_component : "",
            action_component : "",
            optional_filters : {},
            current_list_head : this.props.current_year,
            update_component : "",
            action_component : "",
            statics : [],
            chart_pickup : {},
            statics_segments : [],
            statics_channels : [],
            statics_trimester : [],
            statics_aux : [],
            statics_segments_aux : [],
            statics_channels_aux : [],
            total_widgets : [],
            total_widgets_channels : [],
            filters_segment : [],
            filters_channels : [],
            filters_channels_aux : [],
            hidden_wdg_time : "show-widget complete",
            hidden_wdg_room_nights : "show-widget complete",
            hidden_wdg_adr : "show-widget complete",
            hidden_wdg_revenue : "show-widget complete",
            hidden_wdg_revpar : "show-widget complete",
            hide_widget_trimester : "hide-widget",
            key_filter_channel : null,
            filter_ms_active : "inactive",
            filter_month_active : "inactive",
            filter_trimester_active : "inactive",
            filter_segment_active : "inactive",
            request_status : "",
            key_trimester : "",
            active_chart_type : { key : "Day", value : "by_day"},
            tab_submodule : 'inactive',
            tab_filters : 'inactive'
        };
    }
    setDefaultValuesModule(){
        let self = this;
        self.setState(self.getDefaultValues(), function(){
            self._widgetByDate.setState(self._widgetByDate.getDefaultValues());
            self._widgetSegment.setState(self._widgetSegment.getDefaultValues());
        });
    }
    callMainRequest(params = {}){
        this.props.app.mainRequest({occupancy_module : params, dashboard_occupancy : this.props.layout.state.active_slide.key})
    }
    getOptionTypeBar = (chart, values_calendar) => {
        let self = this;
        
        if(chart === "data_calendar"){
            let option = calendarTrending(values_calendar);
            return option;
        }else{
            return degreeOccupancyTime(this.state.data_degree_occupancy_time);
        }
    }
    // updateBox(result){
    //     this.setState(function(){
    //         let dialog          = dialogOcupanccy(result.data.dialog);
    //         const month_params  = result.data.dialog.month_params;
    //         const day_params    = result.data.dialog.day_params;
    //         dialog.buttons      = this.getButtonsDetails(month_params, day_params);
    //         return { 
    //             dialog : dialog,
    //             update_component : result.data.dialog.day_params.date,
    //             action_component : "click_calendar"
    //         }
    //     });
    // }
    handleClickMenuItem(item, menu) {
        this.setState({
            current_hotel : item,
            action_component : "other"
        }, function(){
            this.forceUpdate();
            this.buildcalendars();
        })
        console.log('ok change');
    } 
    handleClickMenu(name) {
        this.setState(function(prevState){
            return {
                hotel_menu_show : prevState.hotel_menu_show === "hide-panel" ? "" : "hide-panel",
                action_component : "other"
                
            }
        })
    }
    // closeWindow(){
    //     this.setState({
    //         dialog : {
    //             container : "",
    //             buttons : ""
    //         },
    //         details_window : "",
    //         action_component : "other"
    //     })
    // }
    shouldComponentUpdate(nextProps, nextState) {
        if(nextState.update_component !== "" && nextState.action_component === "click_calendar"){
            if(this.state.update_component === nextState.update_component){
                return false
            }else{
                return true;
            }
        }else{
            return true;
        }
        
        
    }
    componentWillReceiveProps(props) {
        let isset = Object.keys(props.response_request).length > 0,
        self = this;
        if (isset){
            let result          = props.response_request["result"];
            //let value_hotels    = result["year_trending"];            
            this.setState({ 
                data_degree_occupancy_time  : result["degree_occupancy_time"],
                action_component : "other",
                //request_occupancy : " show"
            })
            // this.state.hotel_calendars = Object.keys(value_hotels).map((key) => {
            //     return (<div>
            //         <h3>{key}</h3>
            //         <ReactEcharts
            //             option={windowsActive(this.props, "occupancy", "production_occupancy") === true ? this.getOptionTypeBar("data_calendar", value_hotels[key]) : {} }
            //             notMerge={false}
            //             lazyUpdate={false}
            //             theme={"theme_name"}
            //             onChartReady={this.onChartReadyCallback}
            //         />
            //     </div>)
            // })

            let response = props.response_request["result"]["data_table_production"]
            let self = this;
            if(Object.keys(response).length > 0){
                self.setState(function (prevState) {                
                    let results = {}
                    if (self.state.filters_segment.length > 0) {
                        let filters_channels_aux = {};
                        Object.keys(response.result).map(function(key) {
                            let rr = response.result[key];
                            filters_channels_aux[key] = {}
                            Object.keys(rr).map(function(key_two) {
                                filters_channels_aux[key][key_two] = {};
                                if(key_two !== "totals"){
                                    //let rr2 = rr[key_two]["channels"]
                                    //Object.keys(rr2).map(function(key_three){
                                        //filters_channels_aux[key][key_two][key_three] = rr2[key_three]
                                    //});
                                }else{
                                    filters_channels_aux[key][key_two] = rr[key_two]
                                }
                            });
                        })

                        results = {
                            filters_channels: filters_channels_aux,
                            statics_segments_aux: response.result,
                            statics_segments: response.result
                        }
                    } else {
                        results = {
                            statics_channels: [],
                            statics_segments: [],
                            statics_aux: response.result,
                            statics: response.result,
                            total_widgets: response.totals
                        }
                    }
                    return results;
                }, function () {
                    let filt;
                    filt = self._widgetByDate.state.current_key_time;
                    let state_statics = Object.assign({}, self.state.statics);
                
                    Object.keys(state_statics).map(function(key){
                        if(filt[key] !== undefined){
                            state_statics[key].state = "active";
                        }else{
                            state_statics[key].state = "inactive";
                        }
                    })
                    self.setState({
                        statics_aux : state_statics,
                        statics : state_statics,
                    },function(){
                        if(Object.keys(self._widgetSegment.state.segmentActive).length > 0){
                            self.getChannels("active", self._widgetSegment.state.segmentActive)
                        }
                    })
                })
            }
        }
    }

    componentDidUpdate(prevProps, prevState){
        if((prevState.data_degree_occupancy_time != this.state.data_degree_occupancy_time) && this.state.data_degree_occupancy_time.month_names.length > 0 ) {
            let params = {
                occupancy_module : {
                    interval_time_selected_reserves: this.props.app.state.occupancy_module.interval_time_selected_reserves,
                    interval_time_selected_production: this.props.app.state.occupancy_module.interval_time_selected_reserves
                },
                _params_module : {dashboard_occupancy : 'production_occupancy'}
            }
            this.getCalendarData(params);
        }
    }

    getCalendarData(params = {}) {
        let self = this;
        let token_request = (Math.random().toString(36).substr(2)) + (Math.random().toString(36).substr(2));
        if(Object.keys(params).length > 0){
            self.props.app.state._params_module = params._params_module

          if (params.dashboard_occupancy !== null) {
            self.props.app.state.dashboard_occupancy = params.dashboard_occupancy;
          }
        }
        var filters = self.props.app.currentFilters({token_request : token_request});
        self.props.app.state._params_module = {};
        self.props.app.state.dashboard_occupanc = "";
        self.setState({
            calendars : "",
            hotel_filters : ""
        });
        var qs = require("qs");
        let URL = postUrlWidgets
        axios({
          method : "POST",
          headers: { 'content-type' : 'application/x-www-form-urlencoded' },
          url : URL, 
          data : qs.stringify(filters),
        }).then(function (response) {
            self.setState({
                calendar_request : response.data,
                request_occupancy : " hide",
            });
            self.props.app.state._params_module = {};
            self.props.app.state.dashboard_occupanc = "";
            self.buildcalendars();

        })
      } 
    // getMonthDetails(back_action = null, month_params){
    //     let self = this
    //     this.setState(function(prevState){
    //         const details_window = "active"
    //         if(details_window === "active" || back_action === true){
    //             var qs = require("qs");
    //             axios.post(api.baseUrl, 
    //                 qs.stringify(self.props.currentFilters({ 
    //                     month_reserves : true,
    //                     optional_filters : self.state.optional_filters
    //                 }) 
    //             ))
    //             .then(result => {
    //                 self.setState({
    //                     request_occupancy : "hide",
    //                     action_component : "other"
    //                 }, function(){
    //                     self.getMonthComponent(result.data)
    //                 })
    //             }).catch(error => { throw error; })
    //         }
    //         return { 
    //             details_window : details_window,
    //             current_list_head : self.props.current_year,
    //             request_occupancy : "",
    //             details_window : "active",
    //             action_component : "other",
    //             current_sublist : {
    //                 year : self.props.current_year,
    //                 month : {
    //                     key : "",
    //                     value : ""
    //                 },
    //                 day : {
    //                     key : "",
    //                     value : ""
    //                 }
    //             }
    //         }
    //     })
    // }
    // getDaysMonth(key_month, string_month, optional_filters){

    //     let self = this;
    //     this.setState(function(prevState){
    //         return {
    //             current_list_head : string_month,
    //             request_occupancy : "",
    //             details_window : "active",
    //             action_component : "other",
    //             top_window : this.hotel_calendars.scrollTop,
    //             optional_filters : optional_filters != null ? optional_filters : prevState.optional_filters,
    //             current_sublist : {
    //                 year : prevState.current_sublist.year,
    //                 month : {
    //                     key : key_month,
    //                     value : string_month
    //                 },
    //                 day : {
    //                     key : "",
    //                     value : ""
    //                 }
    //             }
    //         }
    //     }, function(){
    //         var qs = require("qs");
    //         axios.post(api.baseUrl, 
    //             qs.stringify(self.props.currentFilters({ 
    //                 month_reserves : true,
    //                 list_month_day : key_month,
    //                 optional_filters : self.state.optional_filters
    //             }) 
    //         )).then(result => {
    //             self.setState({
    //                 request_occupancy : "hide",
    //                 action_component : "other"
    //             }, function(){
    //                 self.getDaysComponent(result.data)
    //             })
    //         }).catch(error => { throw error; })
    //     })
        
    // }
    // getDayRoomTypes(date, string_day, optional_filters){
    //     let self = this;
    //     this.setState(function(prevState){
    //         return {
    //             current_list_head : string_day,
    //             request_occupancy : "",
    //             details_window : "active",
    //             action_component : "other",
    //             top_window : this.hotel_calendars.scrollTop,
    //             optional_filters : optional_filters != null ? optional_filters : prevState.optional_filters,
    //             current_sublist : {
    //                 year : prevState.current_sublist.year,
    //                 month : {
    //                     key : prevState.current_sublist.month.key,
    //                     value : prevState.current_sublist.month.value
    //                 },
    //                 day : {
    //                     key : string_day,
    //                     value : string_day
    //                 }
    //             }
    //         }
    //     }, function(){
    //         var qs = require("qs");
    //         axios.post(api.baseUrl, 
    //             qs.stringify(self.props.currentFilters({ 
    //                 list_room_types_day : date,
    //                 optional_filters : self.state.optional_filters
    //             }) 
    //         )).then(result => {
    //             self.setState({
    //                 request_occupancy : "hide",
    //                 action_component : "other"
    //             }, function(){
    //                 self.getDayRoomTypesComponent(result.data)
    //             })
    //         }).catch(error => { throw error; })
    //     })
    // }
    // getMonthComponent(result){
    //     let list_result = Object.keys(result).map((key) => {

    //         const props_btn_more = {
    //             className : `filter-row inactive`,
    //             onClick : this.getDaysMonth.bind(this, result[key].month_string, result[key].month_format, result[key].optional_filters)
    //         }
    //         return (
    //             <div class="column-grid">
    //                 <div class="row-grid">
    //                     <span className="title" children={result[key].month_format} />
    //                     <span {...props_btn_more} />
    //                 </div>
    //                 <div class="row-grid" children={`${result[key].room_stock}`} />
    //                 <div class="row-grid" children={`${result[key].tAva}`} />
    //                 <div class="row-grid" children={`${result[key].tAva}`} />
    //                 <div class="row-grid" children={`${result[key].tOos}`} />
    //                 <div class="row-grid" children={`${result[key].tOcc}`} />
    //                 <div style={{backgroundColor: `${result[key].indicator}`}} class="row-grid" children={` `} />
    //             </div>
    //         )
    //     })
    //     this.setState({
    //         current_list_result : list_result,
    //         action_component : "other"
    //     })
    // }
    // getDaysComponent(result){
    //     let list_result = Object.keys(result).map((key) => {

    //         const props_btn_more = {
    //             className : `filter-row inactive`,
    //             onClick : this.getDayRoomTypes.bind(this, result[key].book_date_format, result[key].day, result[key].optional_filters)
    //         }
    //         return (
    //             <div class="column-grid">
    //                 <div class="row-grid">
    //                     <span className="title" children={result[key].day} />
    //                     <span {...props_btn_more} />
    //                 </div>
    //                 <div class="row-grid" children={`${result[key].stock}`} />
    //                 <div class="row-grid" children={`${result[key].available}`} />
    //                 <div class="row-grid" children={`${result[key].sold}`} />
    //                 <div class="row-grid" children={`${result[key].oos}`} />
    //                 <div class="row-grid" children={`${result[key].occupancy}`} />
    //                 <div style={{backgroundColor: `${result[key].indicator}`}} class="row-grid" children={` `} />
    //             </div>
    //         )
    //     })
    //     this.setState({
    //         current_list_result : list_result,
    //         action_component : "other"
    //     })
    // }
    // getDayRoomTypesComponent(result){
    //     let list_result = Object.keys(result).map((key) => {
    //         return (
    //             <div class="column-grid">
    //                 <div class="row-grid" children={result[key].name} />
    //                 <div class="row-grid" children={`${result[key].stock}`} />
    //                 <div class="row-grid" children={`${result[key].available}`} />
    //                 <div class="row-grid" children={`${result[key].sold}`} />
    //                 <div class="row-grid" children={`${result[key].oos}`} />
    //                 <div class="row-grid" children={`${result[key].occupancy}`} />
    //                 <div style={{backgroundColor: `${result[key].indicator}`}} class="row-grid" children={` `} />
    //             </div>
    //         )
    //     })
    //     this.setState({
    //         current_list_result : list_result,
    //         action_component : "other"
    //     })
    // }
    // getButtonsDetails(month_params, day_params){

    //     const day_props = {
    //         onClick : this.getDayRoomTypes.bind(this, day_params.date, day_params.string_day, day_params.optional_filters)
    //     }
    //     const month_props = {
    //         onClick : this.getDaysMonth.bind(this, month_params.key_month, month_params.string_month, month_params.optional_filters)
    //     }
    //     return (
    //         <div className="get-details">
    //             <a {...day_props} children={"VER DAY"} />
    //             <span/>
    //             <a {...month_props} children={"VER MONTH"} />
    //         </div>
    //     )
    // }
    // backSection(){
    //     if(this.state.current_sublist.day.key !== ""){
    //         this.getDaysMonth(this.state.current_sublist.month.key, this.state.current_sublist.month.value)
    //     }else if(this.state.current_sublist.month.key !== ""){
    //         this.getMonthDetails(true, null)
    //     }
    // }

    buildcalendars(){
        let hotels,
        self = this,
        all_hotels = (
            <li 
                key={"list-hotel-all"} 
                className={"all" === self.state.current_hotel.value ? " active" : ""} 
                onClick={this.handleClickMenuItem.bind(this, { key  : "All locations", value : "all" }, "menu_hotel")}>
                All locations
            </li>);
        
        if(Object.keys(this.props.active_hotels).length >= 1){
            hotels = this.props.active_hotels;
            this.state.hotel_filters = Object.keys(hotels).map((key, index) => {
                const props = {
                    key : `list-hotel-${index}`,
                    className : hotels[key].value === self.state.current_hotel.value ? " active" : "",
                    onClick : this.handleClickMenuItem.bind(this, { key : hotels[key].hotel, value: hotels[key].value }, "menu_hotel")
                }
                return <li {...props} children={hotels[key].hotel} />;
            });
        }else if(Object.keys(this.props.active_hotels).length === 0){
            hotels = this.props.hotels;
            this.state.hotel_filters = Object.keys(hotels).map((key, index) => {
                const props = {
                    key : `list-hotel-${index}`,
                    className : hotels[key]._id === self.state.current_hotel.value ? " active" : "", 
                    onClick : this.handleClickMenuItem.bind(this, { key : hotels[key].name, value: hotels[key]._id }, "menu_hotel")
                }
               return <li {...props} children={hotels[key].name} />;
            });
        }
        this.state.hotel_filters.unshift(all_hotels)
        let isset = Object.keys(this.state.calendar_request).length > 0,
            calendars_room; 
        if (isset){
            let result          = this.state.calendar_request["result"];
            let value_hotels    = result["year_trending"];            
            
            this.state.calendars = Object.keys(value_hotels).map((key) => {
                const values_room = value_hotels[key]["room_type_series"];
                if(self.state.current_hotel.value !== "all" || Object.keys(value_hotels).length === 1){
                    calendars_room = Object.keys(values_room).map((key_room) => {
                       if(values_room[key_room]['max_value'] > 0) {
                           return (
                            <div key={`key-rooms-${key_room}`}>
                                <h3>{key_room}</h3>
                                <ReactEcharts
                                    option={this.getOptionTypeBar("data_calendar", values_room[key_room]) }
                                    notMerge={true}
                                    lazyUpdate={true}
                                    theme={"theme_name"}
                                />
                            </div>
                            )
                        }
                    })
                }
                if(self.state.current_hotel.value === value_hotels[key]["ref"] || self.state.current_hotel.value === "all" || Object.keys(value_hotels).length === 1){
                    return (
                        <div key={`key-hotels-${key}`}>
                            <h3>{key}</h3>
                            <ReactEcharts
                                option={this.getOptionTypeBar("data_calendar", value_hotels[key]) }
                                notMerge={true}
                                lazyUpdate={true}
                                theme={"theme_name"}
                                //onChartReady={this.onChartReadyCallback}
                            />
                            <div className="room-calendars">
                                { calendars_room }
                            </div>
                        </div>
                    )
                }
            })
        }
    }
    render() {
        //this.buildcalendars();
        return (
            <section>
                <div className={"datagrid-widget occupancy-by-trending"} ref="occupancy-window">
                    <div className="container-fluid">
                        <div className="row header-widget">
                            <div className="col-md-12 options-widget">
                                <span className="title"> OCCUPANCY TREND</span>
                                <div className="opt">
                                    <div className={"select-style " + this.state.hotel_menu_show  } onClick={this.handleClickMenu.bind(this, "hotel_menu_show") }>
                                    <span className="white">
                                        <span>{this.state.current_hotel.key}</span>
                                        <ul>
                                            {this.state.hotel_filters}
                                        </ul>
                                    </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="current-values">
                            <div className="row">
                                <div className={"col-md-12 hotel-calendars " + this.state.details_window} ref={(e) => { this.hotel_calendars = e; }}>
                                    <div style={ { top : this.state.top_window } } className={"load-dinamyc " + this.state.request_occupancy}>
                                        <span>Cargando...</span>
                                    </div>
                                    {/* <div style={ { top : this.state.top_window } } className={`datagrid-widget occupancy-by-availability details-window ${this.state.details_window}`} ref={(e) => { this.details_window = e; }}>
                                        <div className="container-fluid">
                                            <div className="row header-widget">
                                                <div className="col-md-12 options-widget">
                                                    <span className={`back ${this.state.current_sublist.month.key === "" ? "hide" : "" }`} children="<" onClick={this.backSection.bind(this)}/>
                                                    <span className="title">
                                                        { wizardDate(this.state.current_sublist) } - Reservas
                                                    </span>
                                                    <span className="close" children="X" onClick={this.closeWindow.bind(this)} />
                                                </div>
                                            </div>
                                            <div className="current-values">
                                                <div className="row">
                                                    <div className="datagrid-list">
                                                        <div class="column-grid header">
                                                            <div class="row-grid">{ this.state.current_list_head }</div>
                                                            <div class="row-grid">ALLOTMENT</div>
                                                            <div class="row-grid">AVAILABILITY</div>
                                                            <div class="row-grid">R/N</div>
                                                            <div class="row-grid">CUARTOS OOS</div>
                                                            <div class="row-grid">OCCUPANCY</div>
                                                            <div class="row-grid">INDICADOR</div>
                                                        </div>
                                                        <div className="current-list-result" children={ this.state.current_list_result } />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                    { this.state.calendars }
                                </div>
                                {/*<div className="col-md-2 type-availability">
                                    <div className="type-cont">
                                        <div>
                                            <span className="t-sto"/>
                                            <span children="Inventario"/>
                                        </div>
                                        <div>
                                            <span className="t-ava"/>
                                            <span children="Disponibilidad"/>
                                        </div>
                                        <div>
                                            <span className="t-sold"/>
                                            <span children="R/N Vendidos"/>
                                        </div>
                                        <div>
                                            <span className="t-oos"/>
                                            <span children="Cuartos OOS"/>
                                        </div>
                                    </div>
                                    {this.state.dialog.container}
                                    {this.state.dialog.buttons}
                                </div>*/}
                            </div>
                        </div>   
                    </div>
                </div>  
                <div className="table-split occupancy">
                    <ByDate
                        layout={this}
                        app={this.props.app}
                        ref={(child) => { this._widgetByDate = child; }}
                    />

                    <div className={"container-aux " + this.state.filter_ms_active}>
                        <Segment
                            layout={this}
                            app={this.props.app}
                            ref={(child) => { this._widgetSegment = child; }}
                        />
                        <Channel
                            app={this.props.app}
                            layout={this}
                            ref={(child) => { this._widgetChannel = child; }}
                        />
                    </div>
                    <Trending
                        app={this.props.app}
                        layout={this}
                        ref={(child) => { this._widgetTrending = child; }}
                    />  
                    <Allotment
                        app={this.props.app}
                        layout={this}
                        ref={(child) => { this._widgetAllotment = child; }}
                    />  
                    <Adr
                        app={this.props.app}
                        layout={this}
                        ref={(child) => { this._widgetAdr = child; }}
                    />  
                    <Revenue
                        app={this.props.app}
                        layout={this}
                        ref={(child) => { this._widgetRevenue = child; }}
                    />  
                </div>   
            </section>
        )
    }
}

export default Production



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/occupancy/views/Production.js